import { DisplayGroupName } from '#src/ui/presentation/display_group_name.tsx';
import { DisplayParticipantName } from '#src/ui/presentation/display_participant_name.tsx';
import { Card, CardLogo } from '@packages/ui/base/card/card';

export interface GroupHeaderCardProps {
  groupName: string;
  participantName: string;
}

export const GroupHeaderCard = ({ groupName, participantName }: GroupHeaderCardProps) => {
  return (
    <Card className="py-6">
      <CardLogo className="mb-2" />
      <h1 className="mb-1 text-2xl font-bold">
        <DisplayGroupName name={groupName} />
      </h1>
      <p className="text-muted-foreground">
        Welcome, <DisplayParticipantName name={participantName} />!
      </p>
    </Card>
  );
};
